var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-breadcrumbs',{staticClass:"px-2 py-3 py-xs-2 pt-xs-4 hidden-print-only",attrs:{"items":_vm.items,"divider":">"}})}
var staticRenderFns = []

export { render, staticRenderFns }